import { NirHelper } from '@Helpers/nir'

export const smsClass = function (count: number) {
  if (count > 20) return 'notice-success'
  if (count > 0) return 'notice-warning'
  return 'notice-danger'
}